import { useState } from 'react';
import type { Nullable } from '@gov-nx/core/types';

export interface UseNullable<T> {
	value: Nullable<T>;
	hasValue: boolean;
	setValue: (value: Nullable<T>) => void;
	setNull: () => void;
}

export const useNullable = <T,>(initial: Nullable<T> = null) => {
	const [value, setValue] = useState<Nullable<T>>(initial);

	return {
		value,
		setValue,
		hasValue: value != null,
		setNull: () => setValue(null),
	};
};
